import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { BasicShapeWidgetMenu } from '../BasicShapeWidgetMenu';
import { LineWidgetMenu } from '../LineWidgetMenu';

interface ShapesMenuProps {
  allowNavFocus?: boolean;
}

export const ShapesMenu = ({ allowNavFocus }: ShapesMenuProps): ReactElement => {
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu' });

  const boxShadow = allowNavFocus ? 'inset var(--vg-shadows-outline)' : 'none';

  return (
    <Box>
      <Tabs isLazy>
        <TabList h='48px'>
          <Tab fontSize='sm' fontWeight='semibold' _focus={{ boxShadow }}>
            {t('shapesMenu.shapes')}
          </Tab>
          <Tab fontSize='sm' fontWeight='semibold' _focus={{ boxShadow }}>
            {t('shapesMenu.lines')}
          </Tab>
        </TabList>
        <TabPanels overflowY={'auto'} height={'calc(100vh - 10rem)'}>
          <TabPanel padding={'0.8rem 0rem 0rem 0.8rem'} _focus={{ boxShadow }}>
            <BasicShapeWidgetMenu />
          </TabPanel>
          <TabPanel padding={'0.8rem 0rem 0rem 0.8rem'} _focus={{ boxShadow }}>
            <LineWidgetMenu />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
